import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment'
import 'moment/dist/locale/ru'
import { settings } from './variables.js'
import axios from 'axios'
import Cookies from 'js-cookie'

// Shop components

import SearchAutocomplete from './vue_components/shop/SearchAutocomplete.vue'

import AddToCartBtn from './vue_components/cart/AddToCartBtn.vue'
import AddToCartTailBtn from './vue_components/cart/AddToCartTailBtn.vue'
import CartBlock from './vue_components/cart/CartBlock.vue'
import CartPage from './vue_components/cart/CartPage.vue'
import CheckoutPage from './vue_components/cart/CheckoutPage.vue'
import CheckoutPersonalForm from './vue_components/cart/CheckoutPersonalForm.vue'
import CheckoutCorporateForm from './vue_components/cart/CheckoutCorporateForm.vue'
import CheckoutDeliveryForm from './vue_components/cart/CheckoutDeliveryForm.vue'
import CheckoutPaymentForm from './vue_components/cart/CheckoutPaymentForm.vue'
import AlfaPaymentStatus from './vue_components/alfa/AlfaPaymentStatus.vue'
import PriceRequestContact from './vue_components/PriceRequestContact.vue'

import CallmeForm from './vue_components/CallmeForm.vue'
import ContactForm from './vue_components/ContactForm.vue'

import LessPriceRequest from './vue_components/LessPriceRequest.vue'
import DeliveryPriceRequest from './vue_components/DeliveryPriceRequest.vue'
import TradePriceOrder from './vue_components/TradePriceOrder.vue'
import OneClickOrder from './vue_components/OneClickOrder.vue'
import ProductSimple from './vue_components/ProductSimple.vue'

const csrftoken = Cookies.get('csrftoken')

Vue.config.productionTip = false
axios.defaults.baseURL = settings.apiBaseUrl

axios.defaults.headers.common['X-CSRFToken'] = csrftoken
axios.defaults.withCredentials = true

Vue.prototype.$axios=axios

moment.locale('ru')

Vue.use(VueMoment, {
    moment,
})


var vm = new Vue({
  el: '#app',
  components: {

    'SearchAutocomplete': SearchAutocomplete,
    'AddToCartBtn': AddToCartBtn,
    'AddToCartTailBtn': AddToCartTailBtn,
    'CartBlock': CartBlock,
    'CartPage': CartPage,
    'CheckoutPage': CheckoutPage,
    'CheckoutPersonalForm': CheckoutPersonalForm,
    'CheckoutCorporateForm': CheckoutCorporateForm,
    'CheckoutDeliveryForm': CheckoutDeliveryForm,
    'CheckoutPaymentForm': CheckoutPaymentForm,
    'AlfaPaymentStatus': AlfaPaymentStatus,
    'CallmeForm': CallmeForm,
    'ContactForm': ContactForm,
    'PriceRequestContact': PriceRequestContact,
    'LessPriceRequest': LessPriceRequest,
    'DeliveryPriceRequest': DeliveryPriceRequest,
    'TradePriceOrder': TradePriceOrder,
    'OneClickOrder': OneClickOrder,
    'ProductSimple': ProductSimple
  },

  data: {
  }

})
